
export const Api_End_Parameters = {

    LoginUser: "/Account/Authenticate",
    createUser: "/Account/CreateUserAccount",
    createContact: "/Contact/CreateContact",
    contactLookup: "/Contact/GetCacheLookups",
    allRoles: '/Account/ReadAllRoles',
    createUserLookups: "/Account/GetCacheLookups",
    allUsers: "/Account/GetAllUserAccounts",
    deactivateUserToggle: '/Account/ActiveDeactiveUsers',
    organizationData: '/Organization/ReadOrganizationDetails',
    updateOrganiazation: "/Organization/UpdateOrganizationInformation",
    allContacts: '/Contact/ReadContact',
    businessData: '/Organization/ReadAllBusinessUnits',
    allTeams: '/Organization/ReadAllTeams',
    createTeam: '/Organization/CreateTeam',
    updateTeam: '/Organization/UpdateTeam',
    updateContact: "/Contact/UpdateContact",
    roleWisePermissions: "/Account/CreateRoleWisePermissions",
    screenPermissionsByRole: "/Account/GetScreenPermissionsByRole",
    rolesPermissionsLookup: '/Account/GetRolesCacheLookups',
    activeInActiveRoles: '/Account/ActiveDeactiveRoles',
    createLead: '/Leads/CreateLeadProspect',
    cacheLookupLeads: '/Leads/GetCacheLookups',
    readLeadsProspect: '/Leads/GetAllLeadProspect',
    createAccount: '/ClientAccount/CreateAccount',
    updateAccount: '/ClientAccount/UpdateAccount',
    accountContactsLookup: '/ClientAccount/GetAccountContact',
    activeInActiveTeams: '/Organization/ActiveDeactiveTeams',
    activateDeactiveContact: '/Contact/ActiveDeactiveContact',
    LeadMarketinglookup: '/Leads/GetMarketingInformationtLookups',
    getDefaultLookUps: 'Lookups/GetDefaultLookups',
    getActiveAccountLookup: "/Lookups/GetActiveAccountLookup",
    getActiveContactLookup: "/Lookups/GetActiveContactLookup",
    getAssoContactLookup: "/Lookups/GetAssocContactLookup",
    leadProspectById: "/Leads/GetLeadProspectbyId",
    getExistingLeadPospects: "/Lookups/Lst_Leads",
    getAllAccounts: "/ClientAccount/GetAllAccounts",
    UpdateLeadProspect: '/Leads/UpdateLeadProspect',
    getContactById: '/Contact/GetContactById',
    getAccountById: '/ClientAccount/GetAccountById',
    leadProspectInfo: '/Leads/GetExistingLeadInfo',
    getAllleadInquiry: '/LeadInquiry/GetAllLeadInquiry',
    getLeadInquiryDataById: '/LeadInquiry/GetLeadInquirybyId',
    updateLeadInquiry: '/LeadInquiry/UpdateLeadInquiry',
    getleadInquiryLookups: '/Lookups/GetLeadInquiryLookups',
    getModules: '/Lookups/GetModules',
    getSubModules: '/Lookups/GetSubModules',
    updateRoleWisePermissions: '/Account/UpdateRoleWisePermissions',
    getcontactsbyAccount: '/ClientAccount/GetContactbyAccount',
    getAllActiveUsers: '/Account/GetAllActiveUsers',
    getTeamsByUserId: '/Account/GetTeamsByUserId',
    updateLeadAssignTo: '/Leads/UpdateLeadAssignTo',
    deleteLeadProspect: '/Leads/DeleteLeadProspect',
    deleteLeadInquiry: '/LeadInquiry/DeleteLeadInquiry',
    createAppointment: '/LeadInquiry/CreateAppointment',
    updateAppointment: '/LeadInquiry/UpdateAppointment',
    getAppointmentById: '/LeadInquiry/GetAppointmentById',
    getAllAppointments: '/LeadInquiry/GetAllAppointments',
    CreateAptResult: '/LeadInquiry/CreateAppointmentResult',
    getAptResultById: '/LeadInquiry/GetAppointmentResultById',
    updateAptResult: '/LeadInquiry/UpdateAppointmentResult',
    getAllProjectDetails: '/Project/GetAllProjectDetails',
    getProjectDetailsbyId: '/Project/GetProjectDetailsbyId',
    updateProjectDetails: '/Project/UpdateProjectDetails',
    getOpportunityDetailsbyId: '/Project/GetOpportunityDetailsbyId',
    upsertOpportunityDetails: '/Project/UpsertOpportunityDetails',
    getAllClientVisitDetails: '/Project/GetAllClientVisitDetails',
    getClientVisitDetailsbyId: '/Project/GetClientVisitDetailsbyId',
    updateClientVisitDetails: '/Project/UpdateClientVisitDetails',
    createClientVisitDetails: '/Project/CreateClientVisitDetails',
    getProjectLookups: '/Lookups/GetProjectLookups',
    getAptTitle: 'LeadInquiry/GetLeadInquiryAppointments',
    upsertJobScope: '/Project/UpsertJobScopeDetails',
    getJobScoprDetailById: '/Project/GetJobScopeDetailsbyId',
    upsertProjectNotes: '/Project/UpsertProjectNotesDetails',
    getAllProjectNotes: '/Project/GetAllProjectNoteDetails',
    getProjectNotesById: '/Project/GetProjectNotesbyId',
    createUpdateContigency: '/Project/CreateUpdateContigency',
    getAllContigency: '/Project/ReadContigencies',
    getContigencyById: '/Project/GetContigencyDetailsbyId',
    createUpdateProjectTask: '/Project/CreateUpdateTask',
    getAllProjectTasks: '/Project/ReadTasks',
    getProjectTaskByID: '/Project/GetTasksById',
    createUpdateFunding: '/Project/CreateUpdateFunding',
    getFundingDetailsById: '/Project/GetFundingDetailsById',
    getJobScopeHistory: '/Project/GetJobScopeAuditLogDetailsById',
    getSpecificationException: '/Project/GetProjectSpecificationExceptionDetails',
    createSpecificationException: '/Project/CreateUpdateSpecificationException',
    getTeamMemberByName: '/Project/GetTeamsMembersByName',
    getTeamMemberByRole: '/Project/GetTeamsMembersByRole',
    upsertProjectAssignmentDetails: '/Project/UpsertProjectAssignmentDetails',
    teamDetailsInProject: '/Project/GetTeamDetailsById',
    systemSuggestionDetails: '/Project/GetSysTeamDetails',
    getEnterpriseMemberByRole: '/Project/GetEnterpriseMembersByRole',
    getEnterpriseMemberByName: '/Project/GetEnterpriseMembersByName',
    getAllAssignments: '/Project/GetAllAssignmentDetails',
    getAssignmentDetailById: '/Project/GetAssignmentDetailsById',
    GetFirstAPSNest: '/Lookups/GetFirstAPSNest',
    GetSecondAPSNest: '/Lookups/GetSecondAPSNest',
    GetThirdAPSNest: '/Lookups/GetThirdAPSNest',
    GetWizardActions: '/Lookups/GetAssociatedProjectStatus',
    GetWizardTabs: '/Lookups/GetWizardTabs',
    GetSaleInfo: '/Project/GetSaleInfoById',
    UpsertSaleInfoDetails: '/Project/UpsertSaleInfoDetails',
    GetSaleInfoById: '/Project/GetSaleInfoById',
    GetContactDetailsInProject: '/Contact/GetContactByProjectId',
    updateContactDetailsInProject: '/Contact/UpdateContacts',
    createProjectApiForStatusUpdate: '/Project/CreateProject',
    getReportPDMActSummary: '/Reports/GetReportPDMActSummary',
    getReportAllCompanies: '/Reports/GetReportAllCompanies',
    getReportAllPDMs: '/Reports/GetReportAllPDMs',
    getReportPerformanceMatrixView: '/Reports/GetReportPerformanceMatrixView',
    updateProjectAction: '/Project/UpdateProjectActions',
    upsertSpecReview: '/Project/UpsertSpecReviewSurvey',
    getSpecReason: '/Project/GetSpecReviewSurveyDetails',
    compareOpportunities: '/Project/CompareOpportunityDetails',
    getAcceptedSaledInfoById: '/Project/GetAcceptSaleInfoById',
    upsertAcceptedSaleInfoDetails: '/Project/UpsertAcceptSaleInfoDetails',
    getPermitById: '/Project/GetPermitbyId',
    upsertprojectPermitDetails: '/Project/UpsertProjectPermitDetails',
    getEcdReviewSurveyDetails: '/Project/GetEcdReviewSurveyDetails',
    upsertECDReviewSurvey: '/Project/UpsertECDReviewSurvey',
    getDrcSignReviewSurveyDetails: '/Project/GetDrcSignReviewSurveyDetails',
    upsertDrcSignReviewSurvey: '/Project/UpsertDrcSignReviewSurvey',
    getPccReviewSurveyDetails: '/Project/GetPccReviewSurveyDetails',
    upsertPccReviewSurvey: '/Project/UpsertPccReviewSurvey',
    createContactFromProject: '/Contact/CreateContactFromProject',
    createProjectAddenda: '/Project/CreateProjectAddenda',
    getAddendaById: '/Project/GetAddendaById',
    getAllAddenda: '/Project/GetAllAddenda',
    updateProjectAddenda: '/Project/UpdateProjectAddenda',
    upsertPromoteToSw: '/Project/UpsertPromoteToSW',
    getPromoteToSw: '/Project/GetPromoteToSW',
    upsertAddendaJobScope: '/Project/UpsertAddendaJobScopeDetails',
    getAddendaJobScopeById: '/Project/GetAddendaJobScopeDetailsbyId',
    upsertPaymentScheduleAddenda: '/Project/UpsertPaymentSchedule',
    getPaymentScheduleAddendaById: '/Project/GetPaymentScheduleById',
    getContactOpportunitiesById: '/Project/GetContactOpportunityDetailsbyId',
    upsertContactOpportunities: '/Project/UpsertContactOpportunityDetails',
    upsertLeadSource: '/Project/UpsertLeadSource',
    getLocation: '/Project/GetLocationDetails',
    renewToken: '/Account/RenewToken',
    projectFolders: '/Project/GetProjectFolders',
    uploadProfilePicture: '/Account/UploadProfilePicture',
    clientViewSummary: '/Project/ProjectClientViewSummary',
    firstAptTicket: '/Project/GetFirstAppointmentTicket',
    uploadFile: '/Project/UploadFile',
    createFolder: '/Project/CreateFolder',
    jobCard: '/Project/GetJobInfoCard',
    getPermitZoning: '/Project/GetPermitDetailsbyId',
    upsertPermitZoning: '/Project/UpsertProjectPermitAndZoning',
    addendaAggrement: '/Project/AddendaAgreement',
    apptConfirmationLetter: '/Project/AppointmentConfirmation',
    getPermissionDocument: '/Project/GetProjectFoldersAccessPermission',
    upsertPermissionsDocument: '/Project/UpsertProjectFoldersAccessPermission',
    getLocationDetailsByAddress: '/Project/GetLocationDetailsbyAddress',
    upsertUserProfileAsync: '/Account/GetUserProfile',
    updateTemplate: "/Account/UpdateTemplate",
    GetListingFiltersLookUps: '/Lookups/GetListingFiltersLookUps',
    sendEmail: "/Email/SendEmailRequest",
    getTeamMembersEmail: "/Project/GetTeamMembersEmails",
    sendEmailAfterAction: '/Project/SendEmailAfterActionUpdate',
    sendEmailOfAddenda: '/Project/SendEmailOfAdenda',
    taskTypeLookup: '/Project/GetTaskTypeList',
    actionLookupPermission: '/Lookups/GetProjectActionLookup',
    getRegionAndSite: '/Project/GetTeamBySiteAndRegionId',
    forgotPassword: '/Account/ForgotPasswordRequest',
    updatePassword: '/Account/UpdatePassword',
    createCustomFolder: '/Project/CreateCustomFolder',
    removeUserAssignment: '/Project/UnassignedUserFromProject',
    documentImagePreview: '/Project/GetImagesPreview',
    getAddendaStatusLookup: '/Lookups/GetAddendaStatusLookup',
    getprintoutPdfDetails: '/Project/GetAcceptanceOfPlane',
    getProjectBinderCover: '/Project/GetProjectBinderCover',
    getProjectCutSheetLabel: '/Project/GetProjectCutSheetLabel',
    getUrlByMunicipality: '/Project/GetUrlByMunicipality',
    templates: '/Project/GetProjectReferalTemplates',
    projectGraph: '/Project/GetProjectStatusSummary',
    projectReportList: '/Project/GetProjectReportListForExcel',
    updateCompanyInfo: '/Organization/UpdateCompanyInformation',
    getCompanyInfo: '/Organization/GetAllCompanyInformation',
    getSiteAndRegionbyZip: "Project/GetSiteAndRegionByZipCode",
    getEnterpriseReport: 'Project/GetEnterpriseReport',
    userProfile: 'Account/GetUserAccountDetailById',
    userUpdateProfile: '/Account/UpdateUserAccountDetail'
}